export default {"src":"/_next/static/media/reserveNowPattern.f6d4085d.svg","height":643,"width":777,"blurWidth":0,"blurHeight":0};